<template>
    <div>
        <div class="form-group row">
            <label class="col-sm-2">{{ $t('managerForm.settingPage.pageTypeB.topText') }}</label>
            <div class="col-sm-10">
                <Editor
                    id="editor-text_above-winning"
                    :model.sync="initWiningForm.extension.text_above"
                    :configError.sync="configWinningFormB.extension.text_above"
                    :configInit="configWinningFormB.extension.text_above"
                    @blur="onHandleValid(initWiningForm.extension.text_above, configWinningFormB.extension.text_above)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-2">{{ $t('managerForm.settingPage.pageTypeB.bottomText') }}</label>
            <div class="col-sm-10">
                <Editor
                    id="editor-text_below-winning"
                    :model.sync="initWiningForm.extension.text_below"
                    :configError.sync="configWinningFormB.extension.text_below"
                    :configInit="configWinningFormB.extension.text_below"
                    @blur="onHandleValid(initWiningForm.extension.text_below, configWinningFormB.extension.text_below)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Editor from '@/components/Editor/main.vue';

import { validateField } from '@/utils/validate_v2';
export default {
    name: 'SettingWinningFormB',
    components: {
        Editor
    },
    props: {
        formWiningInit: {
            type: Object,
            default: () => ({})
        },
        configWinningFormB: {
            type: Object,
            default: () => ({})
        },
        typeSettingScreen: {
            type: String,
            default: 'text'
        }
    },
    data() {
        return {
            initWiningForm: {}
        };
    },
    methods: {
        onHandleValid(valueField, configField) {
            validateField(valueField, configField);
        },

        getDataFormWining() {
            return JSON.parse(JSON.stringify(this.initWiningForm));
        },
        resetDataFormWining() {
            this.initWiningForm = JSON.parse(JSON.stringify(this.formWiningInit));
        }
    },
    watch: {
        formWiningInit: {
            handler: function (newVal) {
                this.initWiningForm = JSON.parse(JSON.stringify(newVal));
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
